module.exports = __webpack_public_path__ + "static/media/play_button.7b23091c.svg";